import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class Ep extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="longerPage container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Season 2, Episode 1: The Founding of Ancient Korea</h1>
                        <h5 className="korean-title">시즌 2, 에피소드 1: 단군과 고조선</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">



<span class="italics">Listen to the episode <a target="_blank" href="https://anchor.fm/learn-korean-culture/episodes/S2--Episode-1-The-Founding-of-Ancient-Korea-e149nla">here</a>!</span> <br></br>

<br></br>
{/* INTRO */}
국경일 (guk gyeong il) - national holiday <br></br>
개천절 (gae cheon jeol) - National Foundation Day <br></br>
고조선 (go jo seon) - first Korean state <br></br>
어떻게 (uh tteok gae) - how <br></br>
탄생하다 (tan saeng ha da) - to be born <br></br>

<br></br>
{/* INTRO TO THE LEGEND */}
단군신화 (dan gun sin hwa) - myth of dangun <br></br>
신화 - myth, legend <br></br>
역사 - history <br></br>
담기다 - to be contained/put in <br></br>
호랑이 (ho rang eeh) - tiger <br></br>
곰 (gom) - bear <br></br>
환웅 (hwan woong) - legendary son of 환인 (Hwanin) and father of 단군 (Dangun). He appears in the 단군신화 (Legend of Dangun). Pictured below. <br></br>
<br></br><img className="epPic-m" src="https://asianews.up.seesaa.net/image/PicsArt_05-24-01.51.59.jpg"></img><br></br><br></br>
이야기 (eeh ya gi) - story <br></br>

<br></br>
{/* DANGUN LEGEND */}
옛날옛날 (yet nal yet nal) - once upon a time <br></br>
하느님 (ha neun nim) - sky god <br></br>
아들 (ah deul) - son <br></br>
인간세상 (in gan sae sang) - world of humans <br></br>
내려오다 (nae ryuh oh dah) - to come down <br></br>
어느날 (uh neu nal) - one day <br></br>
찾아오다 (cha zah oh dah) - to find and come <br></br>
인간 (in gan) - human <br></br>
되게 해달라고 (dwae gae hae dal la go) - to help become <br></br>
소원을 빌다 (so won eul bil da) - to wish <br></br>
<br></br>Pictured below: artist's rendition of 환웅 (Hwangwoong) with the bear and tiger<br></br><img className="epPic" src="http://monthly.chosun.com/upload/1601/1601_474.jpg"></img><br></br><br></br>
쑥 (ssook) - mugwort <br></br>
마늘 (ma neul) - garlic <br></br>
주다 (juh da) - to give <br></br>
백일 (baek il) - 100 days <br></br>
빛 (beet) - light <br></br>
안 보다 (ahn bo da) - to not look <br></br>
사람 (sah ram) - human <br></br>
될 수 있다 (dweul sooh it da) - can become <br></br>
말했어요 (mal het suh yo) - said <br></br>
그래서 (geu rae suh) - so <br></br>
동굴 (dong gul) - cave <br></br>
안 (ahn) - inside <br></br>
살다 (sal dah) - to live <br></br>
포기하다 (po gi ha da) - to give up <br></br>
성공하다 (sung gong ha da) - to be successful <br></br>
결혼하다 (gyeoul hon ha dah) - to marry <br></br>
낳다 (nat dah) - to give birth to <br></br>
기원전 (gi won jun) - BC (before christ), so 기원전 2333년 means 2333BC <br></br>
세우다 (sae woo dah) - to stand up/erect <br></br>
<br></br>Pictured below: 고조선<br></br>
<img className="epPic" src="https://koreanhistoricaldramas.com/wp-content/uploads/2014/03/gochosony.jpg"></img><br></br><br></br>

<br></br>
{/* MEANING OF GOJOSEON */}
국가 (guk gah) - country, state <br></br>
조선 (jo seon) - original name of 고조선 (gojoseon)  <br></br>
고요한 (go yo han) - serene <br></br>
아침 (ah chim) - morning <br></br>
나라 (nah rah) - country <br></br>
뜻 (ddeut) - meaning <br></br>
갖다 (gat da) - to have <br></br>

<br></br>
{/* GOJOSEON LAWS*/}
아주 (ah juh) - very <br></br>
특이하다 (teuk eeh ha da) - to be interesting <br></br>
법 (bup) - law <br></br>
많다 (man da) - to be a lot <br></br>
남편 (nam pyeon) - husband <br></br>
아내 (ah nae) - wife <br></br>
질투 (jil tooh) - jealousy <br></br>
심하다 (sim ha dah) - to be too much, overwhelming <br></br>
죽이다 (juk eeh da) - to kill <br></br>
도둑 (doh dook) - burglar <br></br>
물건 (mul gun) - item <br></br>
12배 (yeol doo bae) - 12 times (the amount of something) <br></br>
갚다 (gahp dah) - to pay back <br></br>
신분 (sin bun) - status <br></br>
높은 (nop eun) - high <br></br>
노비 (noh bi) - salve <br></br>
무덤 (mooh dum) - grave <br></br>
같이 (gat eeh) - together <br></br>
묻었어요 (mud ut suh yo) - buried <br></br>

<br></br>
{/* BRIEF HISTORY OF GOJOSEON */}
아까 말했듯이 (ah kka mal het deu ssi) - as mentioned before <br></br>
청동기 시대 (chung dong gi si dae) - bronze age <br></br>
시작하다 (si jak ha da) - to start <br></br>
연나라 (yeon nah rah) - ancient Chinese state <br></br>
위만 (wi man) - military leader from 연나라 (yeon nah rah) <br></br>
왕 (wang) - king <br></br>
싸우다 (ssah ooh dah) - to fight <br></br>
멸망하다 (myeol mang ha dah) - to collapse, to end <br></br>
<br></br>





                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <Ep></Ep>
        </div>
    );
}


  const Episode = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Episode;